import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { EMAIL, FACEBOOK, INSTAGRAM, PHONE, PHONE_HREF } from "@/components/Nav";

export default function Footer() {
  return (
    <footer className="border-t border-white/15 bg-navy px-5 py-14 sm:px-10 xl:px-16" data-testid="footer">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
        <div>
          <div className="flex items-center gap-4">
            <span className="flex h-14 w-14 items-center justify-center overflow-hidden rounded-full border-2 border-royal bg-white">
              <img src="/logo.png" alt="Gone Today Junk Removal logo" className="h-full w-full scale-110 object-cover" />
            </span>
            <p className="font-display text-4xl uppercase text-white sm:text-5xl">Gone Today</p>
          </div>
          <p className="mt-2 font-mono2 text-[11px] uppercase tracking-[0.3em] text-white/50">
            Junk Removal — Massachusetts &amp; Rhode Island
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <a
            href={PHONE_HREF}
            data-testid="footer-call-link"
            className="flex items-center gap-3 font-display text-2xl text-white transition-colors duration-200 hover:text-royal"
          >
            <Phone className="h-5 w-5" strokeWidth={2.5} />
            {PHONE}
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-email-link"
            className="flex items-center gap-3 text-sm text-white/70 transition-colors duration-200 hover:text-white"
          >
            <Mail className="h-4 w-4" strokeWidth={2} />
            {EMAIL}
          </a>
          <div className="mt-2 flex items-center gap-4">
            <a
              href={INSTAGRAM}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Gone Today Junk Removal on Instagram"
              data-testid="footer-instagram-link"
              className="flex items-center gap-2 font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/60 transition-colors duration-200 hover:text-royal"
            >
              <Instagram className="h-4 w-4" strokeWidth={2} />
              Instagram
            </a>
            <a
              href={FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Gone Today Junk Removal on Facebook"
              data-testid="footer-facebook-link"
              className="flex items-center gap-2 font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/60 transition-colors duration-200 hover:text-royal"
            >
              <Facebook className="h-4 w-4" strokeWidth={2} />
              Facebook
            </a>
          </div>
        </div>
      </div>
      <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-white/40">
          © {new Date().getFullYear()} Gone Today Junk Removal
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-white/40">
          Run by Clay Tyler
        </p>
      </div>
    </footer>
  );
}
